export const BIZDAY_CONSTANT = {
  // csvファイル名
  CSV_FILENAME: 'businessdays',
  // 対象テーブル
  TARGET_TABLE: 'bizday',
};
